import { Box } from "@mui/material";
import React from "react";
import InstituteAdminDashboard from "./InstituteAdminDashboard";
import SuperAdminDashboard from "./SuperAdminDashboard";
import TrainerDashboard from "./TrainerDashboard";
import InterviewerDashboard from "./InterviewerDashboard";

const Dashboard = () => {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        p: 1,
      }}
    >
      {(() => {
        const role = localStorage.getItem("role");

        if (role === "INSTITUTE_ADMIN") return <InstituteAdminDashboard />;
        if (role === "SUPER_ADMIN") return <SuperAdminDashboard />;
        if (role === "INTERVIEWER") return <InterviewerDashboard />;
        if (role === "STUDENT" || role === "TRAINER")
          return <TrainerDashboard />;

        return null;
      })()}
    </Box>
  );
};

export default Dashboard;
